module.exports = __webpack_public_path__ + "img/proof.b346937d.jpg";